<template lang="pug">
  card.help-card
    .col
      h3.heading {{ $t('help.software.heading') }}
      p {{ $t('help.software.body') }}
      a.button.button--white-outline(:href="$t('help.software.button.url')" target='_blank') {{ $t('help.software.button') }}
    .col
      strong.note {{ $t('help.guides.info.label') }}
      ul
        li
          a(:href="$t('help.guides.solution.url')" target='_blank') {{ $t('help.guides.solution') }}
        li
          a(:href="$t('help.guides.material.url')" target='_blank') {{ $t('help.guides.material') }}
        li
          a(:href="$t('help.guides.finishing.url')" target='_blank') {{ $t('help.guides.finishing') }}

</template>

<script>
import card from '@/components/common/card.vue'

export default {
  components: { card }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';

  .help-card {
    display: flex;
    width: 100%;
    padding: 3em 2em;
    color: white;
    background-color: $blue !important;
    box-shadow: none;
    border: none;
  }

  .col {
    flex: 1;
    padding: 0 1em;
  }

  .heading {
    margin-bottom: 1em;
    font-size: 1.1em;
    font-weight: 600;
    text-transform: uppercase;
  }

  .note {
    font-size: 14px;
    line-height: normal;
    font-weight: 600;
  }

  .button {
    margin-top: 2em;
  }

  p {
    font-size: .9em;
    line-height: 1.8;
  }

  ul {
    text-transform: uppercase;
    letter-spacing: 1px;
    line-height: 22px;
    font-size: 14px;
    font-weight: 600;
    margin: 1em 0;
    width: 100%;

    @media only screen and (max-width: $mobile) {
      flex-direction: row;
      display: block;
      height: auto;
    }

    li {
      position: relative;
      padding-left: 15px;

      opacity: 0.75;
      margin-right: 1em;

      &:hover {
        opacity: 1;
      }

      &:after {
        content: "\f105";
        font-family: FontAwesome;
        left: 1px;
        position:absolute;
        top:0;
      }
    }
  }

</style>
